<section class="playground">
  <h2 class="playground__heading">Area card</h2>
  <p class="playground__hint">
    <code>common-area-card</code> — variantes <code>type=picture</code> / <code>type=icon</code>, rating, capacity y
    <code>chip</code> vía <code>app-info-chip</code> (<code>MunilyAreaCardChipConfig</code>).
  </p>

  <div class="playground__grid">
    <div class="playground__controls">
      <label class="playground__field">
        <span>type</span>
        <select [(ngModel)]="type">
          <option *ngFor="let t of types" [value]="t">{{ t }}</option>
        </select>
      </label>

      <label class="playground__field">
        <span>title</span>
        <input type="text" [(ngModel)]="title" />
      </label>

      <label class="playground__field">
        <span>description</span>
        <textarea rows="4" [(ngModel)]="description"></textarea>
      </label>

      <label class="playground__field">
        <span>capacity</span>
        <input type="text" [(ngModel)]="capacity" />
      </label>

      <label class="playground__field">
        <span>chipLabel</span>
        <input type="text" [(ngModel)]="chipLabel" />
      </label>

      <label class="playground__field">
        <span>chipColor</span>
        <select [(ngModel)]="chipColor">
          <option *ngFor="let c of chipColors" [value]="c">{{ c }}</option>
        </select>
      </label>

      <label class="playground__field">
        <span>chipSize</span>
        <select [(ngModel)]="chipSize">
          <option *ngFor="let s of chipSizes" [value]="s">{{ s }}</option>
        </select>
      </label>

      <label class="playground__field">
        <span>chip.shape</span>
        <select [(ngModel)]="chipShape">
          <option *ngFor="let s of chipShapes" [value]="s">{{ s }}</option>
        </select>
      </label>

      <label class="playground__field">
        <span>chip.infoChipType (filled / outline)</span>
        <select [(ngModel)]="chipInfoType">
          <option *ngFor="let t of chipInfoTypes" [value]="t">{{ t }}</option>
        </select>
      </label>

      <label class="playground__field">
        <span>rating</span>
        <input type="text" [(ngModel)]="rating" />
      </label>

      <label class="playground__field playground__field--checkbox">
        <input type="checkbox" [(ngModel)]="showRating" />
        <span>showRating</span>
      </label>

      <label class="playground__field playground__field--checkbox">
        <input type="checkbox" [(ngModel)]="showMenuButton" />
        <span>showMenuButton</span>
      </label>

      <label class="playground__field">
        <span>imageUrl (opcional)</span>
        <input type="text" [(ngModel)]="imageUrl" placeholder="https://..." />
      </label>

      <label class="playground__field">
        <span>imageFit</span>
        <select [(ngModel)]="imageFit">
          <option *ngFor="let f of imageFits" [value]="f">{{ f }}</option>
        </select>
      </label>
    </div>

    <div class="playground__preview">
      <p class="playground__preview-title">Preview</p>
      <div class="playground__preview-box">
        <common-area-card [data]="data" (select)="onSelect()" (menuClick)="onMenuClick()"></common-area-card>
      </div>
      <p *ngIf="lastEvent" class="playground__meta">{{ lastEvent }}</p>
    </div>
  </div>
</section>

